const langSwitcher = document.querySelector('.language-switcher')
const langDropdown = document.querySelector('.language-switcher__dropdown')
const activeDropdown = document.querySelector('.language-switcher__active')

var dropdownOpen = false

function toggleDropdown() {
	dropdownOpen ? closeDropdown() : openDropdown()
}

function openDropdown() {
	dropdownOpen = true
    langDropdown.classList.add('active')
    langSwitcher.classList.add('active')
}

function closeDropdown() {
	dropdownOpen = false
    langDropdown.classList.remove('active')
	langSwitcher.classList.remove('active')

}

if (langSwitcher) {
	langSwitcher.addEventListener('click', toggleDropdown)
	activeDropdown.addEventListener('click', toggleDropdown)
}